/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList";
import themeConfig from "@/../themeConfig.js";
import colors from "@/../themeConfig.js";

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  id: "", // From Auth
  name: "", // From Auth
  authId: "",
  photoURL: "", // From Auth
  userRole: "",
  userEmail: "",
  idTokenLoaded: false,
  idToken: "empty",
  team: {
    id: ""
  }
};

// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  var prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
  var mq = function(query) {
    return window.matchMedia(query).matches;
  };

  if ("ontouchstart" in window || window.DocumentTouch) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
  return mq(query);
};

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  AppActiveUser: userDefaults,
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  is_touch_device: is_touch_device(),
  mainLayoutType: themeConfig.mainLayoutType || "vertical",
  navbarSearchAndPinList: navbarSearchAndPinList,
  reduceButton: themeConfig.sidebarCollapsed,
  verticalNavMenuWidth: "default",
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  starredPages: navbarSearchAndPinList["pages"].data.filter(
    page => page.is_bookmarked
  ),
  theme: themeConfig.theme || "light",
  themePrimaryColor: colors.primary,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,
  settingList: [],
  userList: [],

  ventilatorManufacturerList: ["Goodstuff", "Crapstuff"],
  ventilatorModelList: [
    { manufacturer: "Goodstuff", model: "SuperGood" },
    { manufacturer: "Goodstuff", model: "UberGood" },
    { manufacturer: "Crapstuff", model: "ReallyCrap" },
    { manufacturer: "Crapstuff", model: "SuperCrap" }
  ],
  ventilatorTypeList: ["GoodType", "MediumType", "BadType"],
  ventilatorStatusList: [
    "In Use",
    "Available",
    "Being Services",
    "Out of Service"
  ],
  ventilatorConditionList: ["Good", "Average", "Poor"],
  serviceRequestPriorityList: [1, 2, 3],
  serviceRequestStatusList: ["Opened", "Being Actioned", "On Hold", "Complete"],
  locationList: [
    {
      id: "0e98ff3b-e137-4081-96e2-c7f171a87816",
      title: "Title 1",
      locationLine1: "location line 1",
      locationLine2: "location line 2"
    },
    {
      id: "ed88648a-6ad0-4212-9544-e82f69bf360a",
      title: "Title 2",
      locationLine1: "location line 10",
      locationLine2: "location line 20"
    }
  ],
  activeHospital: "",
  globalData: {
    dateRange: [],
    activeCases: [],
    newCases: [],
    totalCases: [],
    criticalCases: [],
    recoveredCases: [],
    newDeaths: [],
    totalDeaths: [],
    globalDataLoading: true
  },
  australianData: {
    dateRange: [],
    activeCases: [],
    newCases: [],
    totalCases: [],
    criticalCases: [],
    recoveredCases: [],
    newDeaths: [],
    totalDeaths: [],
    australianDataLoading: true
  },
  australianLiveData: {
    dataSets: {
      totalAusVentilator: [],
      totalAusIcu: [],
      totalAusHospital: [],
      totalAusTest: []
    },
    dateRange: []
  },
  australianLiveDataLoaded: false,
  victorianData: {
    dateRange: [],
    activeCases: [],
    newCases: [],
    totalCases: [],
    criticalCases: [],
    recoveredCases: [],
    newDeaths: [],
    totalDeaths: [],
    victorianDataLoading: true
  },
  victorianLiveData: {
    dataSets: {
      totalAusVentilator: [],
      totalVicIcu: [],
      totalVicHospital: [],
      totalVicTest: []
    },
    dateRange: []
  },
  victorianLiveDataLoaded: false,
  hospitalData: {},
  chartHeight: 0,
  lancetRssResults: [],
  nejmRssResults: [],
  jamaRssResults: [],
  ersjRssResults: [],
  articleKeywordMatches: ["covid", "cov-2", "corona"]
};

export default state;
